import { useMemo } from "react";
import { getPaymentGateway, getPaymentProviderName } from "./gateways/index.js";

export function usePaymentGateway() {
  const gateway = useMemo(() => getPaymentGateway(), []);
  const provider = getPaymentProviderName();

  return { gateway, provider };
}
